import type { Locale } from '../lib/i18n';
import { EN } from './en';
import { ES } from './es';
import { PT } from './pt-PT';

export type TranslatableLocale = Exclude<Locale, 'pt-BR'>;

/** Chaves são o texto original em português (Brasil); pt-BR não precisa de tradução. */
export const DICT: Record<TranslatableLocale, Record<string, string>> = {
  'pt-PT': PT,
  en: EN,
  es: ES
};
